import { FilterStore } from "@/api/generatedTypes";

export const getStoresByCity = (stores: FilterStore[], city: string) => {
  const searchFor = city === "Интернет-магазин" ? "интернет магазин" : city;
  return stores.filter((store) => {
    return store.city?.toLowerCase() === searchFor.toLowerCase();
  });
};
